<script setup>
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'

const { t, tm } = useI18n()

const openQuestionIndex = ref(null)

const toggleAnswer = index => {
  openQuestionIndex.value = openQuestionIndex.value === index ? null : index
}
</script>

<template>
  <div class="questions-section-wrapper">
    <div class="questions-container" id="takeaway-faq">
      <h2>{{ t('new_customer.faqTitle') }}</h2>
      <div class="questions">
        <div
          v-for="(question, i) in tm('new_customer.frequentlyAskedQuestions')"
          :key="`question_${i}`"
        >
          <div class="question">
            <div class="question-title" @click="toggleAnswer(i)">
              <img
                src="../assets/icons/select-down-blue.svg"
                alt="select-down"
                class="question-icon"
              />
              {{ question.question }}
            </div>
            <div
              class="question-answer"
              v-show="openQuestionIndex === i"
              v-html="question.answer"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.questions-section-wrapper {
  background-color: #f6f2f1;
}

.questions-container {
  max-width: 1293px;
  display: flex;
  flex-direction: column;
  justify-items: flex-start;
  margin: 0 auto;
  padding: 20px 30px;
}

.questions-container h2 {
  font-size: 34px;
  line-height: 43px;
  color: #242e30;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 30px;
}

.question {
  margin-bottom: 20px;
}

.question-title {
  font-family: 'JETSansVF2', Arial, sans-serif;
  font-size: 22px;
  line-height: 39px;
  cursor: pointer;
  color: #242e30;
  padding: 10px;
  display: inline-flex;
  align-items: flex-start;
}

.question-title .question-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  margin-top: 8px;
}

.question-answer {
  font-family: 'JETSansVF2', Arial, sans-serif;
  font-size: 18px;
  line-height: 28px;
  padding: 5px 20px 10px 45px;
  color: #555;
  transition: max-height 0.3s ease-out;
}

.question-answer {
  overflow: hidden;
}

.question-answer.open {
  max-height: 300px;
}

@media (max-width: 768px) {
  .questions-container h2 {
    font-size: 20px;
    line-height: 24px;
    text-align: center;
  }

  .question-title {
    font-size: 14px;
    line-height: 17px;
    white-space: normal;
  }

  .question-answer {
    font-size: 14px;
    line-height: 24px;
  }

  .question-title .question-icon {
    width: 16px;
    height: 16px;
    margin-top: 0;
  }
}
</style>
